let CHAIN_ID = window.injectedEnv?.CHAIN_ID || process.env.CHAIN_ID;
export const MAINNET_TRX_URL = CHAIN_ID === "1" ? "https://tronscan.org" : "https://shasta.tronscan.org";
export const MAINNET_ETH_URL = CHAIN_ID === "1" ? "https://etherscan.io" : "https://sepolia.etherscan.io";
export const WALLET_CHECK_TIMEOUT_IN_SECONDS = window.injectedEnv?.WALLET_CHECK_TIMEOUT_IN_SECONDS || 60;
export const INTERVAL_CHECKING_WALLET = 5000;
export const CHANGE_WALLET_ADDRESS_MESSAGE = "Введите другой адрес кошелька";
export const NEED_APPROVE_RISK_MANAGER_MESSAGE = "Требуется одобрение риск офицера";
export const WALLET_CHECKS_CARRIED_MESSAGE = "Необходимые проверки проведены";
export const INITIATE_WALLET_CHECK_MESSAGE =
  "Инициировать проверку кошельков получателя и транзитного кошелька";
export const CHECK_WALLETS_REQUIRED = "Требуется провести проверку кошельков";
export const WE_ENV_WS_FALLBACK_TIMEOUT_IN_SECONDS =
  window.injectedEnv?.WE_ENV_WS_FALLBACK_TIMEOUT_IN_SECONDS || 30;

